import 'regenerator-runtime/runtime';

const cartEndpoint = 'https://shows.edcjcc.org/wdcjcc/api/v3/basket';

/**
 * Counts all possible item types in the Spektrix basket response.
 * This includes tickets, memberships, merchandise, etc.
 *
 * @param {Object} basket - The full basket object returned from the API.
 * @return {number} - Total number of items in the cart.
 */
function countBasketItems(basket) {
	const keys = [
		'ticketSubscriptions',
		'merchandiseItems',
		'donations',
		'membershipSubscriptions',
		'giftVouchers',
		'tickets',
	];

	return keys.reduce((total, key) => {
		return total + (Array.isArray(basket[key]) ? basket[key].length : 0);
	}, 0);
}

/**
 * Inserts or updates the cart item count next to the cart icon in the top menu.
 * Only applies to the /jxj/ site to avoid affecting other multisite sections.
 *
 * @param {number} count - Total items in the cart.
 */
function injectCartBadge(count) {
	if (!window.location.pathname.startsWith('/jxj/')) return;

	const cartIcon = document.querySelector(
		'nav.main-header__utility-nav i.icon-cart'
	);
	if (!cartIcon) return;

	const cartLink = cartIcon.closest('a');
	if (!cartLink) return;

	let badge = cartLink.querySelector('.cart-count-badge');
	if (!badge) {
		badge = document.createElement('span');
		badge.className = 'cart-count-badge';
		badge.style.marginTop = '3px';
		cartLink.appendChild(badge);
	}

	badge.textContent = `(${count})`;
}

/**
 * Calls the Spektrix /basket API endpoint and updates the UI based on cart contents.
 * Handles authentication via credentials: 'include' to retain session cookies.
 */
function fetchCartAndUpdate() {
	fetch(cartEndpoint, {
		credentials: 'include',
		headers: { 'X-Ignore-Intercept': 'true' },
	})
		.then((response) => {
			if (!response.ok) throw new Error(`HTTP ${response.status}`);
			return response.json();
		})
		.then((basket) => {
			const count = countBasketItems(basket);
			injectCartBadge(count);
		})
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.warn('[Cart Count] Failed to fetch:', error);
		});
}

/**
 * Overrides the global fetch() to monitor basket-related requests.
 * When a cart-related call is made, the cart count is automatically updated.
 */
function interceptBasketUpdates() {
	const originalFetch = window.fetch;
	window.fetch = function (input, init = {}) {
		const url = typeof input === 'string' ? input : input.url;
		const headers = (init && init.headers) || {};
		const skip = headers['X-Ignore-Intercept'];

		return originalFetch.apply(this, arguments).then(async (response) => {
			if (
				typeof url === 'string' &&
				url.includes('membership-subscriptions') &&
				response.ok &&
				!skip
			) {
				setTimeout(fetchCartAndUpdate, 300);
			}
			return response;
		});
	};
}

// Initialize the script
function initCartCount() {
	fetchCartAndUpdate();
	interceptBasketUpdates();
}

export default initCartCount;
